import React, {useEffect, useRef} from "react";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import {CalenderIcon, SearchIconSubmitDoc} from "../../../Assets/svg";
import AddNewDocType from "../SubmitDocumentForm/AddNewDocType";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numeric from "../../../utils/NumericFunction";
import {getDocumentPageData, submitDocumentFormAction} from "../../Store/SubmitDocumentForm";
import {useDispatch, useSelector} from "react-redux";


const TopSection = (props) => {
  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();


  const documentDescriptionRef = useRef();

  const dateCal = useRef(null);
  useEffect(() => {
    dateCal?.current?.addEventListener("keydown", function (event) {
      if (event.keyCode === 9) {
        dateCal.current.closeCalendar();
      }
    });
  }, [dateCal]);
  const searchClickHandler = () => {
    // اینجا چک میکنم این موردی که وارد کرده چیه دقیقا؟
    // اگه جزو آیدی ها نبود میگم شرمنده این مورد معتبر نیست
    // اگه آخری بود. ینی میخواد یه سند جدید اضاف کنه. پس میرم فوکس میکنم روی توضیحات
    // و اگه یکی از اون موارد قبلی بود هم میرم میفرستم بالا که درخواست بزنه و فرم و اطلاعات رو بیاره

    if (sendData.documentCode === "") {
      toast("لطفا یک مقدار وارد کنید");
      return;
    }
    if (sendData.documentPageData.id.includes(+sendData.documentCode)) {
      if (+sendData.documentCode === sendData.documentPageData.id[sendData.documentPageData.id.length - 1]) {
        // فوکس کن روی توضیحات
        // documentDescriptionRef.current.querySelector("input").focus();
      } else {
        // props.requestEditHandler(+sendData.documentCode);
      }
    } else {
      toast("لطفا یک مقدار معتبر در قسمت شماره سند وارد کنید");
    }
  };

  function confirmRemoveData() {
    Swal.fire({
      title: "آیا مطمئنید؟",
      text: "تمامی اطلاعات جدول حذف می شوند.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "حذف",
      cancelButtonText: "لغو",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(submitDocumentFormAction.fillInput({documentCode: ""}))
        // props.onRemoveDocumentNumberField();
      }
    });
  }


  try {
    return (
      <div>

        <form
          onSubmit={(e) => e.preventDefault()}
          autoComplete={"off"}
          className={"d-flex justify-content-start flex-wrap gap-1"}
        >
          <div className={"position-relative input__label width__210"}>
            <label htmlFor="documentNumber">شماره سند:</label>
            <input
              placeholder={"شماره سند"}
              className={""}
              list="documentNumberList"
              id="documentNumber"
              name="documentNumber"
              value={sendData?.documentCode}
              onChange={(e) => {
                 dispatch(submitDocumentFormAction.fillInput({documentCode: e.target.value}))
              }}
            />
            <div
              className={"delete__icon"}
              onClick={() => {
                confirmRemoveData();
              }}
              title={"حذف"}
            >
              &times;
              {/*<i className="fas fa-times-circle"></i>*/}
            </div>
            <div
              onClick={searchClickHandler}
              className={'search__icon'}

            >
              {/*<i className={"fa fa-search"}/>*/}
              <SearchIconSubmitDoc/>
            </div>

            <datalist id="documentNumberList">
              {sendData?.documentPageData?.id?.map((v, index) => (
                <option key={index} value={v}/>
              ))}
            </datalist>

          </div>
          <div ref={documentDescriptionRef} className={'width__310'}>

            <div className="input__label width__310">
              <label htmlFor="description">توضیحات سند</label>
              <input
                autoComplete={"off"}
                className={""}
                id={"description"}
                placeholder={"توضیح"}
                value={sendData.documentDescription}
                onChange={(e) => {
                  dispatch(submitDocumentFormAction.fillInput({documentDescription: e.target.value}))

                }}
              />
            </div>
          </div>
          <AddNewDocType/>


          <div className={"input__label width__210"}>
            <label htmlFor={"dateHereForm"}>تاریخ</label>
            <div
              className="form-control ltr d-flex"
            >
              <CalenderIcon/>
              <DatePicker
                id={"dateHereForm"}
                calendar={persian}
                className="classNameOfDatePicker "
                placeholder="تاریخ"
                name={"bame"}
                locale={persian_fa}
                ref={dateCal}
                calendarPosition="bottom-right"
                hideOnScroll
                value={sendData.documentDate}
                onChange={(DateObject) => {
                  if (DateObject) {
                    const temp = numeric.p2e(DateObject.toLocaleString());
                    dispatch(submitDocumentFormAction.fillInput({documentDate: temp}))


                  } else {
                    dispatch(submitDocumentFormAction.fillInput({documentDate: ''}))

                  }
                }}
              />
            </div>
          </div>
          <div className={'input__label width__210'}>
            <label htmlFor={"timeInput"}>زمان</label>
            <input
              className={""}
              id={"timeInput"}
              type="time"
              name="appt-time"
              value={sendData.documentTime}
              step="1"
              onChange={(e) => {
                dispatch(submitDocumentFormAction.fillInput({documentTime: e.target.value}))
              }}
            />
          </div>
        </form>
      </div>
    );
  } catch (error) {
    return <div>{JSON.stringify(error)}</div>
  }

};


export default TopSection